import React, { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { Row, Col, Card, CardBody, Container, Button, Table, Modal, Input } from 'reactstrap';
import toastr from 'toastr';
import { TOAST_OPTIONS, Config } from 'helpers/backend_helper';
import 'toastr/build/toastr.min.css';
import * as url from '../../helpers/url_helper';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Seetup = () => {
  toastr.options = TOAST_OPTIONS;

  // State for approvers
  const [approverList, setApproverList] = useState([]);
  const [modalApprover, setModalApprover] = useState(false);
  const [entity, setEntity] = useState('');
  const [scope, setScope] = useState('');
  const [scopeId, setScopeId] = useState('');
  const [approverId, setApproverId] = useState('');
  const [approverRecordId, setApproverRecordId] = useState('');

  // State for chemicals
  const [chemicalsList, setChemicalsList] = useState([]);
  const [chemical, setChemical] = useState('');
  const [chemicalCode, setChemicalCode] = useState('');
  const [chemicalId, setChemicalId] = useState('');
  const [modalChemical, setModalChemical] = useState(false);

  // State for staff titles
  const [rolesList, setRolesList] = useState([]);
  const [titleId, setTitleId] = useState('');
  const [title, setTitle] = useState('');
  const [reportsTo, setReportsTo] = useState('');
  const [modalTitle, setModalTitle] = useState(false);

  // State for departments
  const [depts, setDepts] = useState([]);
  const [deptId, setDeptId] = useState('');
  const [deptName, setDeptName] = useState('');
  const [parentDeptId, setParentDeptId] = useState('');
  const [modalDept, setModalDept] = useState(false);

  // State for districts
  const [districtList, setDistrictList] = useState([]);
  const [districtId, setDistrictId] = useState('');
  const [districtName, setDistrictName] = useState('');
  const [districtCode, setDistrictCode] = useState('');
  const [districtZones, setDistrictZones] = useState(0);
  const [modalDistrict, setModalDistrict] = useState(false);

  // State for supporting data
  const [regionList, setRegionList] = useState([]);
  const [staffList, setStaffList] = useState([]);

  // General state
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Entity options
  const entityOptions = ['WQ', 'PRODUCTION', 'WORKORDERS', 'PAYROLL', 'LEAVE', 'APPRAISALS', 'TRAINING'];

  // Scope options
  const scopeOptions = ['DEPARTMENT', 'REGION', 'SECTION', 'ALL'];

  const removeBodyCss = () => {
    document.body.classList.add('no_padding');
  };

  // Toggle functions for modals
  const togApprover = () => {
    setModalApprover(!modalApprover);
    removeBodyCss();
  };
  const togDept = () => {
    setModalDept(!modalDept);
    removeBodyCss();
  };
  const togDistrict = () => {
    setModalDistrict(!modalDistrict);
    removeBodyCss();
  };
  const togChemical = () => {
    setModalChemical(!modalChemical);
    removeBodyCss();
  };
  const togTitle = () => {
    setModalTitle(!modalTitle);
    removeBodyCss();
  };

  // Handlers for approvers
  const handleSaveApprover = () => {
    if (!entity) {
      toastr.error('Select an entity');
      return;
    }
    if (!scope) {
      toastr.error('Select a scope');
      return;
    }
    if (!approverId) {
      toastr.error('Select an approver');
      return;
    }
    if (scope !== 'ALL' && !scopeId) {
      toastr.error('Select a scope ID');
      return;
    }
    const data = {
      id: isEdit ? approverRecordId : '',
      entity,
      scope,
      scope_id: scope == 'ALL' ? '-' : scopeId,
      approver_id: approverId,
      action: isEdit ? 'edit' : 'add',
    };
    setIsLoading(true);
    axios
      .post(url.APPROVERS, JSON.stringify(data), Config)
      .then((r) => {
        toastr.success(r.data.message);
        setIsEdit(false);
        setEntity('');
        setScope('');
        setScopeId('');
        setApproverId('');
        setApproverRecordId('');
        togApprover();
        getData();
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to save approver');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteApprover = (d) => {
    const data = {
      id: d.id,
      action: 'delete',
    };
    setIsLoading(true);
    axios
      .post(url.APPROVERS, JSON.stringify(data), Config)
      .then((r) => {
        toastr.success(r.data.message);
        getData();
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to delete approver');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Handlers for departments
  const handleSaveDept = () => {
    if (deptName.trim().length < 2) {
      toastr.error('Enter department/section name');
      return;
    }
    const data = {
      id: isEdit ? deptId : '',
      name: deptName,
      parent_department: parentDeptId || null,
      action: isEdit ? 'edit' : 'add',
    };
    setIsLoading(true);
    axios
      .post(url.DEPTS, JSON.stringify(data), Config)
      .then((r) => {
        if (r.data.status == '1') {
          toastr.success(r.data.message);
          setIsEdit(false);
          setDeptName('');
          setDeptId('');
          setParentDeptId('');
          togDept();
          getData();
        } else {
          toastr.error(r.data.message);
        }
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to save department/section');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteDept = (d) => {
    const data = {
      id: d.id,
      action: 'delete',
    };
    setIsLoading(true);
    axios
      .post(url.DEPTS, JSON.stringify(data), Config)
      .then((r) => {
        if (r.data.status == '1') {
          toastr.success(r.data.message);
          getData();
        } else {
          toastr.error(r.data.message);
        }
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to delete department/section');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleClickDeptDetails = (c) => {
    setIsEdit(true);
    setDeptId(c.id);
    setDeptName(c.name);
    setParentDeptId(c.parent_department || '');
    togDept();
  };

  // Handlers for districts
  const handleSaveDistrict = () => {
    if (districtName.trim().length < 2) {
      toastr.error('Enter district name');
      return;
    }
    const data = {
      id: isEdit ? districtId : '',
      name: districtName,
      code: districtCode,
      areas: parseInt(districtZones, 10) || 0,
      action: isEdit ? 'edit' : 'add',
    };
    setIsLoading(true);
    axios
      .post(url.TERRITORIES, JSON.stringify(data), Config)
      .then((r) => {
        toastr.success(r.data.message);
        setIsEdit(false);
        setDistrictId('');
        setDistrictName('');
        setDistrictCode('');
        setDistrictZones(0);
        togDistrict();
        getData();
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to save district');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteDistrict = (d) => {
    const data = {
      id: d.id,
      action: 'delete',
    };
    setIsLoading(true);
    axios
      .post(url.TERRITORIES, JSON.stringify(data), Config)
      .then((r) => {
        toastr.success(r.data.message);
        getData();
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to delete district');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Handlers for chemicals
  const handleSaveChemical = () => {
    if (chemical.trim().length < 2) {
      toastr.error('Enter chemical name');
      return;
    }
    const data = {
      id: isEdit ? chemicalId : '',
      name: chemical,
      code: chemicalCode,
      units: 'kgs',
      action: isEdit ? 'edit' : 'add',
    };
    setIsLoading(true);
    axios
      .post(url.CHEMICALS, JSON.stringify(data), Config)
      .then((r) => {
        toastr.success(r.data.message);
        setIsEdit(false);
        setChemical('');
        setChemicalCode('');
        setChemicalId('');
        togChemical();
        getData();
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to save chemical');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteChemical = (d) => {
    const data = {
      id: d.id,
      action: 'delete',
    };
    setIsLoading(true);
    axios
      .post(url.CHEMICALS, JSON.stringify(data), Config)
      .then((r) => {
        toastr.success(r.data.message);
        getData();
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to delete chemical');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Handlers for staff titles
  const handleSaveTitle = () => {
    if (title.trim().length < 2) {
      toastr.error('Enter title');
      return;
    }
    const data = {
      id: isEdit ? titleId : '',
      title,
      reportsTo: reportsTo || null,
      action: isEdit ? 'edit' : 'add',
    };
    setIsLoading(true);
    axios
      .post(url.TITLES, JSON.stringify(data), Config)
      .then((r) => {
        toastr.success(r.data.message);
        setIsEdit(false);
        setTitle('');
        setReportsTo('');
        setTitleId('');
        togTitle();
        getData();
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to save title');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteTitle = (d) => {
    const data = {
      id: d.id,
      action: 'delete',
    };
    setIsLoading(true);
    axios
      .post(url.TITLES, JSON.stringify(data), Config)
      .then((r) => {
        toastr.success(r.data.message);
        getData();
      })
      .catch((e) => {
        toastr.error(e.response?.data?.message || 'Failed to delete title');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Fetch data
  const getData = async () => {
    setIsLoading(true);
    try {
      const [approvers, chemicals, titles, depts, territories, regions, users] = await Promise.all([
        axios.post(url.APPROVERS, { action: 'filter' }, Config),
        axios.get(url.CHEMICALS, Config),
        axios.get(url.TITLES, Config),
        axios.get(url.DEPTS, Config),
        axios.get(url.TERRITORIES, Config),
        axios.get(url.REGIONS, Config),
        axios.post(url.USERSFILTER, JSON.stringify({}), Config),
      ]);
      setApproverList(approvers.data);
      setChemicalsList(chemicals.data);
      setRolesList(titles.data);
      setDepts(depts.data);
      setDistrictList(territories.data);
      setRegionList(regions.data);
      setStaffList(users.data);
    } catch (e) {
      toastr.error('Failed to load data');
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // Filter departments and sections
  const departments = depts.filter((d) => !d.parent_department);
  const sections = depts.filter((d) => d.parent_department);

  // Get parent department name
  const getParentDeptName = (parentId) => {
    const parent = depts.find((d) => d.id === parentId);
    return parent ? parent.name : '-';
  };
  const truncate = (text, maxLength = 32) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <div className="page-content">
      <MetaTags>
        <title>Settings | {url.COMPANY}</title>
      </MetaTags>
      <Container fluid>
        <Row>
          <Col xl={6}>
            <Card>
              <h5 className="card-header bg-transparent border-bottom text-uppercase">Approvers</h5>
              <CardBody>
                <Row className="justify-content-center">
                  {approverList.length > 0 ? (
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table className="table table-sm mb-3 table-hover">
                          <thead>
                            <tr>
                              <th>No</th>
                              <th>Entity</th>
                              <th>Scope</th>
                              <th>Scope Name</th>
                              <th>Approver</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {approverList.map((d, k) => (
                              <tr key={d.id}>
                                <th scope="row">{k + 1}</th>
                                <td>{d.entity}</td>
                                <td>{d.scope}</td>
                                <td>{truncate(d.scope_name)}</td>
                                <td>{d.approver_name}</td>
                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                  <Link
                                    to="#"
                                    className="text-success me-2"
                                    onClick={() => {
                                      setIsEdit(true);
                                      setApproverRecordId(d.id);
                                      setEntity(d.entity);
                                      setScope(d.scope);
                                      setScopeId(d.scope_id);
                                      setApproverId(d.approver_id);
                                      togApprover();
                                    }}
                                  >
                                    <i className="mdi mdi-pencil font-size-18" />
                                  </Link>
                                  <Link
                                    to="#"
                                    className="text-danger"
                                    onClick={() => handleDeleteApprover(d)}
                                  >
                                    <i className="mdi mdi-delete font-size-18" />
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-warning display-4" />
                      </div>
                      <h6>No Approvers set</h6>
                    </div>
                  )}
                  <div className="col-auto">
                    <Button
                      color="primary"
                      className="btn-sm btn-rounded"
                      onClick={() => {
                        setIsEdit(false);
                        setApproverRecordId('');
                        setEntity('');
                        setScope('');
                        setScopeId('');
                        setApproverId('');
                        togApprover();
                      }}
                    >
                      Add Approver
                    </Button>
                  </div>
                </Row>
              </CardBody>
            </Card>

            <Card>
              <h5 className="card-header bg-transparent border-bottom text-uppercase">Districts</h5>
              <CardBody>
                <Row className="justify-content-center">
                  {districtList.length > 0 ? (
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table className="table table-sm mb-3 table-hover">
                          <thead>
                            <tr>
                              <th>No</th>
                              <th>Name</th>
                              <th>Code</th>
                              <th>Total Areas</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {districtList.map((d, k) => (
                              <tr key={d.id}>
                                <th scope="row">{k + 1}</th>
                                <td>{d.name}</td>
                                <td>{d.code}</td>
                                <td>{d.areas}</td>
                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                  <Link
                                    to="#"
                                    className="text-success me-2"
                                    onClick={() => {
                                      setIsEdit(true);
                                      setDistrictId(d.id);
                                      setDistrictName(d.name);
                                      setDistrictCode(d.code);
                                      setDistrictZones(d.areas);
                                      togDistrict();
                                    }}
                                  >
                                    <i className="mdi mdi-pencil font-size-18" />
                                  </Link>
                                  <Link
                                    to="#"
                                    className="text-danger"
                                    onClick={() => handleDeleteDistrict(d)}
                                  >
                                    <i className="mdi mdi-delete font-size-18" />
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-warning display-4" />
                      </div>
                      <h6>No Districts set</h6>
                    </div>
                  )}
                  <div className="col-auto">
                    <Button
                      color="primary"
                      className="btn-sm btn-rounded"
                      onClick={() => {
                        setIsEdit(false);
                        setDistrictId('');
                        setDistrictName('');
                        setDistrictCode('');
                        setDistrictZones(0);
                        togDistrict();
                      }}
                    >
                      Add District
                    </Button>
                  </div>
                </Row>
              </CardBody>
            </Card>

            <Card>
              <h5 className="card-header bg-transparent border-bottom text-uppercase">Chemicals</h5>
              <CardBody>
                <Row className="justify-content-center">
                  {chemicalsList.length > 0 ? (
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table className="table table-sm mb-3 table-hover">
                          <thead>
                            <tr>
                              <th>No</th>
                              <th>Name</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {chemicalsList.map((d, k) => (
                              <tr key={d.id}>
                                <th scope="row">{k + 1}</th>
                                <td>{d.name || d.chemical}</td>
                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                  <Link
                                    to="#"
                                    className="text-success me-2"
                                    onClick={() => {
                                      setIsEdit(true);
                                      setChemicalId(d.id);
                                      setChemical(d.name || d.chemical);
                                      setChemicalCode(d.code);
                                      togChemical();
                                    }}
                                  >
                                    <i className="mdi mdi-pencil font-size-18" />
                                  </Link>
                                  <Link
                                    to="#"
                                    className="text-danger"
                                    onClick={() => handleDeleteChemical(d)}
                                  >
                                    <i className="mdi mdi-delete font-size-18" />
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-warning display-4" />
                      </div>
                      <h6>No Production chemicals set</h6>
                    </div>
                  )}
                  <div className="col-auto">
                    <Button
                      color="primary"
                      className="btn-sm btn-rounded"
                      onClick={() => {
                        setIsEdit(false);
                        setChemicalId('');
                        setChemical('');
                        setChemicalCode('');
                        togChemical();
                      }}
                    >
                      Add Chemical
                    </Button>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col xl={6}>
            <Card>
              <h5 className="card-header bg-transparent border-bottom text-uppercase">Departments & Sections</h5>
              <CardBody>
                <Row className="justify-content-center">
                  {depts.length > 0 ? (
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table className="table table-sm mb-3 table-hover">
                          <thead>
                            <tr>
                              <th>No</th>
                              <th>Name</th>
                              <th>Parent Department</th>
                              <th>Type</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {depts.map((c, k) => (
                              <tr key={c.id}>
                                <td>{k + 1}</td>
                                <td>{truncate(c.name)}</td>
                                <td>{truncate(getParentDeptName(c.parent_department))}</td>
                                <td>{c.parent_department ? 'Section' : 'Department'}</td>
                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                  <Link
                                    to="#"
                                    className="text-success me-2"
                                    onClick={() => handleClickDeptDetails(c)}
                                  >
                                    <i className="mdi mdi-pencil font-size-18" />
                                  </Link>
                                  <Link
                                    to="#"
                                    className="text-danger"
                                    onClick={() => handleDeleteDept(c)}
                                  >
                                    <i className="mdi mdi-delete font-size-18" />
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-warning display-4" />
                      </div>
                      <h6>No departments or sections set</h6>
                    </div>
                  )}
                  <div className="col-auto">
                    <Button
                      color="primary"
                      className="btn-sm btn-rounded"
                      onClick={() => {
                        setIsEdit(false);
                        setDeptId('');
                        setDeptName('');
                        setParentDeptId('');
                        togDept();
                      }}
                    >
                      Add Department/Section
                    </Button>
                  </div>
                </Row>
              </CardBody>
            </Card>

            <Card>
              <h5 className="card-header bg-transparent border-bottom text-uppercase">Staff Titles</h5>
              <CardBody>
                <Row className="justify-content-center">
                  {rolesList.length > 0 ? (
                    <Col md={12}>
                      <div className="table-responsive">
                        <Table className="table table-sm mb-3 table-hover">
                          <thead>
                            <tr>
                              <th>No</th>
                              <th>Title</th>
                              <th>Reports to</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {rolesList.map((d, k) => (
                              <tr key={d.id}>
                                <th scope="row">{k + 1}</th>
                                <td>{d.title}</td>
                                <td>{d.reportsToName || '-'}</td>
                                <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                                  <Link
                                    to="#"
                                    className="text-success me-2"
                                    onClick={() => {
                                      setIsEdit(true);
                                      setTitleId(d.id);
                                      setTitle(d.title);
                                      setReportsTo(d.reportsTo || '');
                                      togTitle();
                                    }}
                                  >
                                    <i className="mdi mdi-pencil font-size-18" />
                                  </Link>
                                  <Link
                                    to="#"
                                    className="text-danger"
                                    onClick={() => handleDeleteTitle(d)}
                                  >
                                    <i className="mdi mdi-delete font-size-18" />
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  ) : (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="mdi mdi-check-circle-outline text-warning display-4" />
                      </div>
                      <h6>No staff titles set</h6>
                    </div>
                  )}
                  <div className="col-auto">
                    <Button
                      color="primary"
                      className="btn-sm btn-rounded"
                      onClick={() => {
                        setIsEdit(false);
                        setTitleId('');
                        setTitle('');
                        setReportsTo('');
                        togTitle();
                      }}
                    >
                      Add Title
                    </Button>
                  </div>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal for Approvers */}
        <Modal isOpen={modalApprover} toggle={togApprover} size="lg" centered backdrop="static">
          <div className="modal-header">
            <h5 className="modal-title">{isEdit ? 'Update' : 'Add'} Approver</h5>
            <button type="button" onClick={togApprover} className="btn-close" aria-label="Close" />
          </div>
          <div className="modal-body">
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Entity</label>
                  <select className="form-select" value={entity} onChange={(e) => setEntity(e.target.value)}>
                    <option value="">Select Entity</option>
                    {entityOptions.map((e) => (
                      <option key={e} value={e}>
                        {e}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Scope</label>
                  <select
                    className="form-select"
                    value={scope}
                    onChange={(e) => {
                      setScope(e.target.value);
                      setScopeId('');
                    }}
                  >
                    <option value="">Select Scope</option>
                    {scopeOptions.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Scope ID</label>
                  <select
                    className="form-select"
                    value={scopeId}
                    onChange={(e) => setScopeId(e.target.value)}
                    disabled={scope === 'ALL'}
                  >
                    <option value="">Select Scope ID</option>
                    {scope === 'DEPARTMENT' &&
                      departments.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.name}
                        </option>
                      ))}
                    {scope === 'REGION' &&
                      regionList.map((r) => (
                        <option key={r.id} value={r.id}>
                          {r.region}
                        </option>
                      ))}
                    {scope === 'SECTION' &&
                      sections.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name}
                        </option>
                      ))}
                    {scope === 'ALL' && <option value="-">All</option>}
                  </select>
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <label className="form-label">Approver</label>
                  <select className="form-select" value={approverId} onChange={(e) => setApproverId(e.target.value)}>
                    <option value="">Select Approver</option>
                    {staffList.map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            {isLoading ? (
              'Please wait...'
            ) : (
              <>
                <Button color="danger" onClick={togApprover}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleSaveApprover}>
                  Save
                </Button>
              </>
            )}
          </div>
        </Modal>

        {/* Modal for Departments */}
        <Modal isOpen={modalDept} toggle={togDept} size="lg" centered backdrop="static">
          <div className="modal-header">
            <h5 className="modal-title">{isEdit ? 'Edit' : 'Add'} {parentDeptId ? 'Section' : 'Department'}</h5>
            <button type="button" onClick={togDept} className="btn-close" aria-label="Close" />
          </div>
          <div className="modal-body">
            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">{parentDeptId ? 'Section' : 'Department'} Name</label>
                  <Input
                    type="text"
                    className="form-control"
                    value={deptName}
                    onChange={(e) => setDeptName(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">Parent Department</label>
                  <select
                    className="form-select"
                    value={parentDeptId}
                    onChange={(e) => setParentDeptId(e.target.value)}
                  >
                    <option value="">None (Department)</option>
                    {departments.map((d) => (
                      <option key={d.id} value={d.id}>
                        {d.name}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            {isLoading ? (
              'Please wait...'
            ) : (
              <>
                <Button color="danger" onClick={togDept}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleSaveDept}>
                  Save
                </Button>
              </>
            )}
          </div>
        </Modal>

        {/* Modal for Districts */}
        <Modal isOpen={modalDistrict} toggle={togDistrict} size="lg" centered backdrop="static">
          <div className="modal-header">
            <h5 className="modal-title">{isEdit ? 'Edit' : 'Add'} District</h5>
            <button type="button" onClick={togDistrict} className="btn-close" aria-label="Close" />
          </div>
          <div className="modal-body">
            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">District</label>
                  <Input
                    type="text"
                    className="form-control"
                    value={districtName}
                    onChange={(e) => setDistrictName(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">Code</label>
                  <Input
                    type="text"
                    className="form-control"
                    value={districtCode}
                    onChange={(e) => setDistrictCode(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">Total Areas</label>
                  <Input
                    type="number"
                    className="form-control"
                    value={districtZones}
                    onChange={(e) => setDistrictZones(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            {isLoading ? (
              'Please wait...'
            ) : (
              <>
                <Button color="danger" onClick={togDistrict}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleSaveDistrict}>
                  Save
                </Button>
              </>
            )}
          </div>
        </Modal>

        {/* Modal for Chemicals */}
        <Modal isOpen={modalChemical} toggle={togChemical} size="lg" centered backdrop="static">
          <div className="modal-header">
            <h5 className="modal-title">{isEdit ? 'Edit' : 'Add'} Chemical</h5>
            <button type="button" onClick={togChemical} className="btn-close" aria-label="Close" />
          </div>
          <div className="modal-body">
            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">Chemical</label>
                  <Input
                    type="text"
                    className="form-control"
                    value={chemical}
                    onChange={(e) => setChemical(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">Code</label>
                  <Input
                    type="text"
                    className="form-control"
                    value={chemicalCode}
                    onChange={(e) => setChemicalCode(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            {isLoading ? (
              'Please wait...'
            ) : (
              <>
                <Button color="danger" onClick={togChemical}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleSaveChemical}>
                  Save
                </Button>
              </>
            )}
          </div>
        </Modal>

        {/* Modal for Titles */}
        <Modal isOpen={modalTitle} toggle={togTitle} size="lg" centered backdrop="static">
          <div className="modal-header">
            <h5 className="modal-title">{isEdit ? 'Edit' : 'Add'} Staff Title</h5>
            <button type="button" onClick={togTitle} className="btn-close" aria-label="Close" />
          </div>
          <div className="modal-body">
            <Row>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">Title</label>
                  <Input
                    type="text"
                    className="form-control"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
              </Col>
              <Col md={12}>
                <div className="mb-3">
                  <label className="form-label">Reports to</label>
                  <select className="form-select" value={reportsTo} onChange={(e) => setReportsTo(e.target.value)}>
                    <option value="">None</option>
                    {rolesList.map((r) => (
                      <option key={r.id} value={r.id}>
                        {r.title}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            {isLoading ? (
              'Please wait...'
            ) : (
              <>
                <Button color="danger" onClick={togTitle}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleSaveTitle}>
                  Save
                </Button>
              </>
            )}
          </div>
        </Modal>
      </Container>
    </div>
  );
};

export default Seetup;